import { AfterViewInit, Component, OnChanges, OnDestroy, OnInit, SimpleChanges,HostListener} from '@angular/core';
import * as React from 'react';
import * as ReactDOM from 'react-dom'

// import TestingComponent from './React-components/TestingComponent';
import { ISlimScrollOptions, SlimScrollEvent } from 'ngx-slimscroll';
import { EventEmitter } from '@angular/core';
import { MediaObserver, MediaChange } from '@angular/flex-layout';
import { Subscription } from 'rxjs';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { LocationStrategy } from '@angular/common';
import { Subject } from 'rxjs';
import { AuthenticationService } from './service/authentication.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { environment } from 'src/environments/environment';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { data } from 'jquery';
import { SessionIdleComponent } from './session-idle/session-idle.component';
import { AgoraConfigService } from 'src/AgoraConfigService';

declare var CKEDITOR: any;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  // template: '<div [id] = "rootId"></div>',
  styleUrls: ['./app.component.css']
})
// export class AppComponent implements OnChanges, AfterViewInit, OnDestroy{
export class AppComponent implements OnInit, OnDestroy {

  //layout show variable
  layoutShow = false;

  //login false
  loginPageDisable = true;

  mediaSub!: Subscription;
  deviceXs!: boolean;
  deviceSm!: boolean;
  deviceMd!: boolean;
  deviceLg!: boolean;
  deviceXl!: boolean;
  showHead: boolean = false;


  rootId = "calendar"
  opts!: ISlimScrollOptions;
  scrollEvents!: EventEmitter<SlimScrollEvent>;

  isLogin:boolean = false;
  userActivity:any;
  userlogout:boolean=false;
  userInactive: Subject<any> = new Subject();
  idleState = 'Not started.';
  timedOut = false;
  lastPing?: Date;
  title = 'angular-idle-timeout';
  show: boolean = true;
  agoraConfigObject: any;


  constructor(private idle: Idle, private keepalive: Keepalive,private dialog :MatDialog,private authService:AuthenticationService,public mediaObserver: MediaObserver, private router: Router, private location: LocationStrategy, private agoraConfig: AgoraConfigService) {
    this.agoraConfigObject = this.agoraConfig.getConfig().endpoints;
    history.pushState(null, window.location.href);
    router.events.subscribe(event => {
      if(event instanceof NavigationEnd) {
        var title = this.constructTitle(router.routerState, router.routerState.root).join('-');
        var userName = localStorage.getItem('userName');
        if((title=="help" || title=="help-web") && userName == undefined){
          this.show=false;
        }
        else {
          this.show = true;
        }
        
      }
    });
    // check if back or forward button is pressed.
    this.location.onPopState(() => {
      history.pushState(null, window.location.href);
      //this.router.navigate(['/']);
      window.location.href = this.agoraConfig.getConfig().apiBaseUrl+this.agoraConfigObject.contextPath
      localStorage.removeItem("userId");
      localStorage.removeItem("userName");
      localStorage.removeItem("currentUser");
      localStorage.clear();
      
    });

         // Using ng -idle
    idle.setIdle(1800);
    // sets a timeout period of 5 seconds. after 10 seconds of inactivity, the user will be considered timed out.
    idle.setTimeout(5);
    // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    idle.onIdleEnd.subscribe(() => { 
      this.idleState = 'No longer idle.'
      
      this.reset();
    });
    
    idle.onTimeout.subscribe(() => {
      this.idleState = 'Timed out!';
      this.timedOut = true;
      
      //window.location.reload();
      this.router.navigate(['/']);
    });
    
    idle.onIdleStart.subscribe(() => {
        this.idleState = 'You\'ve gone idle!'
        
        this.dialog.open(SessionIdleComponent, {
         }).afterClosed().subscribe(response => {
          let confirmRes = response
          if(confirmRes){
            this.logout();
         }
         else{
          this.stay();
         }
       });
       //this.childModal.show();
    });

    idle.onTimeoutWarning.subscribe((countdown) => {
      this.idleState = 'You will time out in ' + countdown + ' seconds!'
    });
  

    // sets the ping interval to 15 seconds
    keepalive.interval(15);

    keepalive.onPing.subscribe(() => this.lastPing = new Date());
    //this.reset();
    this.authService.getUserLoggedIn().subscribe(userLoggedIn => {
      if (userLoggedIn) {
        idle.watch()
        this.timedOut = false;
      } else {
        idle.stop();
      }
    })
    

    }



    reset() {
      this.idle.watch();
      this.timedOut = false;
    }

    /*hideChildModal(): void {
      //this.childModal.hide();
    }*/
  
    stay() {
     // this.childModal.hide();
      this.reset();
    }
  
    logout() {
     // this.childModal.hide();
      localStorage.removeItem("userId");
      localStorage.removeItem("userName");
      localStorage.removeItem("currentUser");
      localStorage.clear();
      this.router.navigate(['/']);
      window.location.reload();
    }

 
  public getLoginValue(data: any) {
    // window.alert("called")
    this.layoutShow = data
    this.loginPageDisable = false
  }
  ngOnInit() {
    this.mediaSub = this.mediaObserver.media$.subscribe((result: MediaChange) => {
      this.deviceXs = result.mqAlias === 'xs' ? true : false
      this.deviceSm = result.mqAlias === 'sm' ? true : false
      this.deviceMd = result.mqAlias === 'md' ? true : false
      this.deviceLg = result.mqAlias === 'lg' ? true : false
      this.deviceXl = result.mqAlias === 'xl' ? true : false
    })
    setInterval(() => {
      this.isLogin = true;
      if(this.isLogin != true){
        this.router.navigate(['/']);
      }
    }, 1); 
  }
   

  
  

  ngDoCheck() {
  }

  ngOnDestroy() {
    this.mediaSub?.unsubscribe();
    for (var instance in CKEDITOR.instances) {
      CKEDITOR.instances[instance].destroy();
    }

  }

  constructTitle(state:any, parent:any):any {
    var data = [];
    if(parent && parent.snapshot.data && parent.snapshot.data.title) {
      data.push(parent.snapshot.data.title);
    }

    if(state && parent) {
      data.push(... this.constructTitle(state, state.firstChild(parent)));
    }
    return data;
  }

}




